import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import { editIntro, filters, products } from "../mock";
import { useReveal } from "../hooks/useReveal";

const ProductCard = ({ p }) => {
  const { ref, inView } = useReveal();
  return (
    <div
      ref={ref}
      className={`group reveal ${inView ? "in-view" : ""} ${p.offset ? "md:mt-16" : ""}`}
    >
      <div className="relative overflow-hidden rounded-sm" style={{ aspectRatio: "3/4" }}>
        <img src={p.image} alt={p.name} className="card-img w-full h-full object-cover" />
        {p.justIn && (
          <span
            className="absolute top-4 left-4 font-mono2 px-3 py-1.5"
            style={{ background: "var(--cream-3)", color: "var(--wine)", fontSize: "0.6rem", letterSpacing: "0.18em" }}
          >
            JUST IN
          </span>
        )}
      </div>
      <h3 className="font-display mt-5 text-2xl" style={{ color: "var(--ink)" }}>{p.name}</h3>
      <p className="font-body text-[0.9rem] mt-1" style={{ color: "var(--muted)" }}>{p.detail}</p>
      <a
        href="https://wa.me/919922345255"
        target="_blank"
        rel="noreferrer"
        className="btn-wine btn-3d mt-5 flex items-center justify-between rounded-sm px-5 py-3.5 font-mono2 w-full"
        style={{ fontSize: "0.64rem", letterSpacing: "0.14em" }}
      >
        ENQUIRE ON WHATSAPP <ArrowRight size={14} />
      </a>
    </div>
  );
};

const TheEdit = () => {
  const [active, setActive] = useState("All");
  const visible = active === "All" ? products : products.filter((p) => p.tags.includes(active));

  return (
    <section id="the-edit" className="paper py-24">
      <div className="max-w-[1360px] mx-auto px-6 md:px-10">
        <span className="eyebrow">{editIntro.eyebrow}</span>
        <div className="grid lg:grid-cols-2 gap-10 mt-6 items-end">
          <h2 className="font-display leading-[0.95]" style={{ color: "var(--wine)" }}>
            <span className="block font-bold" style={{ fontSize: "clamp(2.4rem,5vw,4.2rem)" }}>{editIntro.titleTop}</span>
            <span className="block italic font-medium" style={{ fontSize: "clamp(2.4rem,5vw,4.2rem)" }}>{editIntro.titleItalic}</span>
          </h2>
          <p className="font-body text-[1.05rem] leading-relaxed max-w-sm lg:justify-self-end lg:text-right" style={{ color: "var(--muted)" }}>
            {editIntro.description}
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-4 mt-12 pb-8" style={{ borderBottom: "1px solid rgba(89,26,32,0.12)" }}>
          <div className="flex flex-wrap gap-3">
            {filters.map((f) => (
              <button
                key={f}
                onClick={() => setActive(f)}
                className="rounded-full px-5 py-2.5 font-mono2 transition-all duration-300"
                style={{
                  fontSize: "0.64rem",
                  letterSpacing: "0.14em",
                  background: active === f ? "var(--wine)" : "transparent",
                  color: active === f ? "var(--cream)" : "var(--wine)",
                  border: `1px solid ${active === f ? "var(--wine)" : "rgba(89,26,32,0.25)"}`,
                }}
              >
                {f.toUpperCase()}
              </button>
            ))}
          </div>
          <span className="eyebrow" style={{ color: "var(--muted)" }}>{visible.length} PIECES</span>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mt-12">
          {visible.map((p) => (
            <ProductCard key={p.id} p={p} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TheEdit;
